import { Plus } from "lucide-react";
import { MatterRolesTable } from "@/components/features/settings/defaults/matter-roles/MatterRolesTable";
import { Button, Text } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import {
  ACTION_PERMISSION_KEYS,
  ACTION_PERMISSION_VALUES,
} from "@/lib/data/static/permissionOptions";
import { useState } from "react";

export default function MatterRolesCard({
  title = "Matter roles",
  addButtonLabel = "Add role",
}: {
  title?: string;
  addButtonLabel?: string;
} = {}) {
  const { hasActionPermission } = useUser();
  const [isAddingRole, setIsAddingRole] = useState(false);

  const canCreate = hasActionPermission(
    ACTION_PERMISSION_KEYS.matterRole,
    ACTION_PERMISSION_VALUES.create,
  );

  return (
    <div className="w-full">
      <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="gap-y-1">
          <Text variant="title">{title}</Text>
        </div>
        {canCreate ? (
          <Button
            variant="foreground"
            size="md"
            className="shrink-0"
            onClick={() => {
              setIsAddingRole(true);
            }}
          >
            <Plus className="h-4 w-4" aria-hidden="true" />
            {addButtonLabel}
          </Button>
        ) : null}
      </div>
      <MatterRolesTable isAdding={isAddingRole} setIsAdding={setIsAddingRole} />
    </div>
  );
}
